function isFramed () {
    let isFramed = false;
    try {
        isFramed = window !== window.top;
    } catch (e) {
        isFramed = true;
    }
    return isFramed;
}

export default isFramed;